import React from 'react'
import './View3.css'
import More3 from './More3'
import Moreimg from './Moreimg'
import Moretext from './Moretext'
import Moreimg2 from './Moreimg2'
import Moretext2 from './Moretext2'
import Moreimg3 from './Moreimg3'
import Moretext3 from './Moretext3'
import Moreimg4 from './Moreimg4'


const View3 = () => {
  return (
    <div>
      <div className="counter-wrapper47">
    <div className="counter47">
        <h1 className='count47' >Fibc Bags</h1>
       
        {/* <Button > <a href="/Contact">Contact Us</a></Button> */}
    </div>
   
   
  </div>
  <More3 />
  <Moreimg />
  <Moretext />
  <Moreimg2 />
  <Moretext2 />
  <Moreimg3 />
  <Moretext3 />
  <Moreimg4 />
  

    </div>
  )
}

export default View3
